<template>
  <transition name="modal">
    <div class="modal-mask" v-if="!!message">
      <div class="modal-wrapper" @click.self="onClose">
        <div class="modal-container" v-bind:class="customClass">
          <div class="modal-header">
            <div class="image">
              <img :src="statusImage" :alt="message" />
            </div>
            <div class="title">
              <h4>{{ title }}</h4>
            </div>
          </div>
          <div class="modal-content">
            <div class="content-text">
              <p>{{ message }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "NotificationModal",
  computed: {
    currentStatus() {
      /**
       * Generar clase para status
       * Default "info"
       */
      const valid = ["info", "success", "alert"];
      return valid.indexOf(this.type) !== -1 ? this.type : "info";
    },
    customClass() {
      const classNames = [this.currentStatus];
      return classNames.join(" ");
    },
    statusImage() {
      /**
       * Generar imagen de status
       */
      const images = {
        info: require(`@/assets/img/1x/info-white.svg`),
        success: require(`@/assets/img/1x/success-white.svg`),
        alert: require(`@/assets/img/1x/alert-white.svg`)
      };

      return images[this.currentStatus];
    },
    ...mapState({
      title: state => state.notificationModal.title,
      message: state => state.notificationModal.message,
      type: state => state.notificationModal.type
    })
  },
  methods: {
    onClose() {
      document.getElementsByTagName("html")[0].classList.remove("lock-scroll");
    }
  },
  beforeUpdate() {
    if (this.message) {
      document.getElementsByTagName("html")[0].classList.add("lock-scroll");
    } else {
      document.getElementsByTagName("html")[0].classList.remove("lock-scroll");
    }
  }
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
  justify-content: center;
}
.modal-wrapper {
  align-self: center;
}
.modal-container {
  width: 560px;
  text-align: center;
  padding: 34px 40px;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  box-sizing: border-box;
  position: relative;
  color: #fff;
}
.modal-header h4 {
  font-size: 0.938rem;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  white-space: normal;
  object-fit: contain;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}
.modal-container.info {
  background-color: #1464a5;
}
.modal-container.success {
  background-color: #388d4f;
}
.modal-container.alert {
  background-color: #b92a45;
}
.image img {
  width: 34px;
  height: auto;
}
.content-text p {
  font-size: 0.938rem;
  margin: 0;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media screen and (max-width: 600px) {
  /* En mobile el modal ocupa toda la pantalla */
  .modal-wrapper {
    align-self: stretch;
    width: 100%;
  }

  .modal-container {
    width: auto;
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 30px;
  }

  .modal-content {
    padding: 16px;
    flex: 1; /* Stretch */
    min-height: 1%; /* Hack: fuerza al hijo flex a tener altura máxima dentro de su contenedor */
  }
  .modal-header {
    padding: 0 16px;
  }
  .modal-header h4 {
    font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
    padding-top: 12px;
    margin-top: 0px;
    margin-bottom: 0.25rem;
  }
}
</style>
